export const sizes = { sidebarWidth: 220 } as const;
